import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UtilityService } from 'src/app/services/utility.service';


@Component({
  selector: 'sponsor-pack-policy',
  templateUrl: './sponsor-pack-policy.component.html',
  styleUrls: ['./sponsor-pack-policy.component.scss']
})
export class SponsorPackPolicyComponent implements OnInit {
  @Input('_isDisplay') _isDisplay
  @Input('stepperComplete') stepperComplete
  @Input('formData') userFormData
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  workingHourDisclaimerForm: FormGroup;
  _isView = true
  _isComplete = false
  whdDate2
  whdSign2
  currentDate = moment().format("MM/DD/YYYY")

  constructor(
    public _formBuilder: FormBuilder,
    public _utilityService: UtilityService,
  ) { }

  ngOnInit(): void {
    // this.createForm()
  }


  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES OF POLICY", changes)
    if (changes._isDisplay && changes._isDisplay.currentValue) this._isView = false
    else this._isView = true


    if (changes.stepperComplete && changes.stepperComplete.currentValue) this._isComplete = true
    else this._isComplete = false

    if (changes.userFormData && changes.userFormData.currentValue) {
      // this.createForm(changes.userFormData.currentValue.details.workingHourDisclaimer)
    }

  }



  // FORM GROUP

  createForm(workingHourDisclaimerDetails?) {
    this.workingHourDisclaimerForm = this._formBuilder.group({
      whdDate2: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdDate2) ? workingHourDisclaimerDetails.whdDate2 : this.currentDate, Validators.required),
      whdSign2: new FormControl((workingHourDisclaimerDetails && workingHourDisclaimerDetails.whdSign2) ? workingHourDisclaimerDetails.whdSign2 : '', Validators.required),
    });
  }

  // UTILITY

  onChange(event, fomrControl, formGroup) {
    console.log("DATE SELECT EVENT", event)
    formGroup.get(fomrControl).patchValue(event)
    console.log("AFTER DATE VALUE ASSIGNED", formGroup.value)
  }


  addSignature(formControl, formGroup) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent, 'user')
      .afterClosed().subscribe((data) => {
        if (data == undefined) return
        else {
          formGroup.get(formControl).patchValue(data)
          console.log("AFTER SIGNATURE ASSIGNED", formGroup.value)
        }
      })
  }

  submitForm() {
    // if (this.workingHourDisclaimerForm.valid) {
    this.formSubmit.emit({ event: 'submit' });
    // } else {
    //   this.workingHourDisclaimerForm.markAllAsTouched()
    // }
  }

}
